"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _numbers = require("../utils/numbers");

var _styles = require("../styles");

var _Icon = _interopRequireDefault(require("./Icon"));

var _utils = _interopRequireDefault(require("./utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Year =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Year, _PureComponent);

  function Year(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.handlePrevRange = _this.handleRangeChange.bind(_assertThisInitialized(_assertThisInitialized(_this)), -15);
    _this.handleNextRange = _this.handleRangeChange.bind(_assertThisInitialized(_assertThisInitialized(_this)), 15);
    return _this;
  }

  var _proto = Year.prototype;

  _proto.handleChange = function handleChange(year) {
    var _this$props = this.props,
        current = _this$props.current,
        onChange = _this$props.onChange,
        onModeChange = _this$props.onModeChange;
    var date = new Date(current.getTime());
    date.setFullYear(year);
    onChange(date);
    onModeChange('month');
  };

  _proto.handleRangeChange = function handleRangeChange(year) {
    var _this$props2 = this.props,
        current = _this$props2.current,
        onChange = _this$props2.onChange;
    onChange(_utils.default.addYears(current, year));
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props3 = this.props,
        current = _this$props3.current,
        value = _this$props3.value;
    var cy = current.getFullYear() - 7;
    var years = (0, _numbers.range)(15, 0).map(function (i) {
      return cy + i;
    });
    return _react.default.createElement("div", {
      className: (0, _styles.datepickerClass)('year-picker')
    }, _react.default.createElement("div", {
      className: (0, _styles.datepickerClass)('header')
    }, _react.default.createElement(_Icon.default, {
      name: "AngleLeft",
      onClick: this.handlePrevRange
    }), _react.default.createElement("span", {
      className: (0, _styles.datepickerClass)('ym')
    }, years[0], " ~ ", years[years.length - 1]), _react.default.createElement(_Icon.default, {
      name: "AngleRight",
      onClick: this.handleNextRange
    })), _react.default.createElement("div", {
      className: (0, _styles.datepickerClass)('list')
    }, years.map(function (y) {
      return _react.default.createElement("span", {
        key: y,
        className: (0, _styles.datepickerClass)(value && value.getFullYear() === y && 'active'),
        onClick: _this2.handleChange.bind(_this2, y)
      }, y);
    })));
  };

  return Year;
}(_react.PureComponent);

Year.propTypes = {
  current: _propTypes.default.object.isRequired,
  onChange: _propTypes.default.func.isRequired,
  onModeChange: _propTypes.default.func.isRequired,
  value: _propTypes.default.object
};
var _default = Year;
exports.default = _default;